import React from 'react'
import { IoIosDocument } from 'react-icons/io'
import styles from './publicationTopicRow.module.scss'
import IcoMoonIcon from '@/components/themes/common/icons/IcoMoonIcon'
import ICON_MAP from '@/components/themes/common/icons/iconMapper'
import { useSelector } from 'react-redux'
import { configSelectors } from '@/store/configs'
import { customerHelper } from '@tweddle-se-team/common/constants'

const { CUSTOMER_IDS } = customerHelper

const showTopicIconByCustomer = {
  [CUSTOMER_IDS.SUBARU]: () => true,
  [CUSTOMER_IDS.NORDICS]: () => false
}

const TYPE_ICONS = {
  video: ({ className }) => <IcoMoonIcon className={className} icon={ICON_MAP.video} />,
  topic: ({ className }) => <IcoMoonIcon className={className} icon={ICON_MAP.file} />
}

/**
 * Subaru Publication Topic Row Component
 * Displays a clickable row with an icon, title, and chevron
 *
 * @param {Object} props
 * @param {string} props.type - Type of publication ('video' or 'topic')
 * @param {string} props.title - Title to display
 * @param {Function} props.onClick - Click handler callback
 * @param {string} props.className - Optional additional className
 */
const PublicationTopicRow = ({ type, title, onClick, className = '' }) => {
  const customerId = useSelector(configSelectors.selectCustomerId)
  const IconComponent = TYPE_ICONS[type] || IoIosDocument
  const showTopicIcon = (showTopicIconByCustomer[customerId] || showTopicIconByCustomer[CUSTOMER_IDS.SUBARU])()

  return (
    <div
      className={`${styles.publicationRow} ${className}`.trim()}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick?.()
        }
      }}
    >
      <div className={styles.leftContent}>
        {showTopicIcon && (
          <div className={styles.iconWrapper}>
            <IconComponent className={styles.icon} aria-hidden="true" />
          </div>
        )}
        <span className={styles.title}>{title}</span>
      </div>

      <div className={styles.rightContent}>
        <IcoMoonIcon className={styles.chevron} icon={ICON_MAP.chevronRight} aria-hidden="true" />
      </div>
    </div>
  )
}

export default PublicationTopicRow
